// extracted by mini-css-extract-plugin
export default {"circle":"Circle_circle__P8SK1","inside":"Circle_inside__BlIHL"};